/**
 * Debounce function to limit the rate at which a function can fire.
 *
 * @param {function} callback The function to debounce.
 * @param {number} delay The delay in milliseconds.
 * @return {(function(...[*]): void)|*}
 */
const debounce = (callback, delay = 250) => {
  if (typeof callback !== 'function') {
    throw new TypeError( 'Expected a function as the first argument' );
  }

  let timeout;
  return (...args) => {
    clearTimeout( timeout );
    timeout = setTimeout( () => callback.apply( this, args ), delay );
  };
}

export default debounce;
